export default {
      id: "infinity-usage",
      viewBox: "0 0 26 20",
      url: __webpack_public_path__ + "sprite.svg#infinity-usage",
      toString: function () {
        return this.url;
      }
    }